import { render, staticRenderFns } from "./agents-select.vue?vue&type=template&id=4a5dca10"
import script from "./agents-select.vue?vue&type=script&lang=js"
export * from "./agents-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports